import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import c from 'classnames';
import Immutable from 'immutable';
import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import MenuSecondaryMenu from '../SecondaryMenu';

import {
  LanguageSwitcher,
} from '../../../components';

import { LANGUAGE_ENGLISH, MENU_NL } from '../../../config/constants';

import './style.scss';

const MainMenuMobile = ({ setMobileMenuVisible }) => {
  const [activeMenuSection, setActiveMenuSection] = useState(null);

  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const IS_ENGLISH = currentLanguage === LANGUAGE_ENGLISH;

  return (
    <div className="MenuMobile">
      <div className="MenuMobile__top">
        <div className="MainMenuMobile">
          <Menu id={MENU_NL}>
            {(items) => {
              return (
                <div>
                  {items.map((item) => {
                    if (item) {
                      const id = item.getIn(['link', 'meta_data', 'entity_id']);
                      const title = item.getIn(['link', 'title']);
                      const url = item.getIn(['link', 'url'], '');
                      const subtree = item.get('subtree', Immutable.Map());
                      const active = activeMenuSection === id;
                      const MainMenuMobileItemClassnames = c('MainMenuMobile__item', {
                        'MainMenuMobile__item--active': active,
                      });

                      if (IS_ENGLISH) {
                        // In case of an English menu, we only want to show the top level
                        // menu items, not their children.
                        return (
                          <CoreLink
                            className="MainMenuMobile__item__link"
                            href={url}
                            onClick={() => setMobileMenuVisible(false)}
                          >
                            <h3 className="MainMenuMobile__item__title">
                              {title}
                              <span className="icon icon-arrow-right icon-variant-2" />
                            </h3>
                          </CoreLink>
                        );
                      }

                      return (
                        <div key={id} className={MainMenuMobileItemClassnames}>
                          <div
                            className="MainMenuMobile__item__link"
                            onClick={() => setActiveMenuSection(id)}
                          >
                            <h3 className="MainMenuMobile__item__title">
                              {title}
                              <span className="icon icon-arrow-right icon-variant-2" />
                            </h3>
                          </div>
                          <div className="MainMenuMobile__item__subtree">
                            <div
                              className="MainMenuMobile__item__link"
                              onClick={() => setActiveMenuSection(null)}
                            >
                              <span className="icon icon-chevron-left" />
                              Terug
                            </div>
                            <div className="MainMenuMobile__item__subtree__title">
                              <CoreLink href={url}
                                onClick={() => {
                                  setMobileMenuVisible(false);
                                  setActiveMenuSection(null);
                                }}
                              >
                                <h3 className="MainMenuMobile__title">
                                  {title}
                                  <span className="icon icon-arrow-right icon-variant-2" />
                                </h3>
                              </CoreLink>
                            </div>
                            <div className="MainMenuMobile__item__subtree__items">
                              {subtree.map((subtreeItem, subtreeItemIndex) => {
                                const subtreeItemUrl = subtreeItem.getIn(['link', 'url'], '');
                                const subtreeItemTitle = subtreeItem.getIn(['link', 'title']);
                                const subtreeItemUrlIsExternal = subtreeItem.getIn(['link', 'route_parameters'], Immutable.Map()).size === 0;

                                return (
                                  <div key={`mobile-subtree-${subtreeItemIndex}`} className="MainMenuMobile__item__subtree__items__item">
                                    <CoreLink
                                      primary
                                      href={subtreeItemUrl}
                                      onClick={() => {
                                        setMobileMenuVisible(false);
                                        setActiveMenuSection(null);
                                      }}
                                    >
                                      {subtreeItemTitle}
                                    </CoreLink>
                                    <span className={`icon icon-${subtreeItemUrlIsExternal ? 'external-link' : 'arrow-right'} icon-variant-2`} />
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                        </div>
                      );
                    }
                  })}
                </div>
              );
            }}
          </Menu>
        </div>
      </div>
      {activeMenuSection === null && (
        <div className="MenuMobile__bottom">
          {/* Language switcher */}
          <LanguageSwitcher />

          {/* Secondary CTA menu */}
          <MenuSecondaryMenu buttonBlock />
        </div>
      )}
    </div>
  );
};

export default MainMenuMobile;
